module.exports = __webpack_public_path__ + "media/assets/icons/quill/link-02d3ce701c7c1f9264ae3bde211b9b1b.svg";